import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Private, logged-in app routes: clean tab titles + noindex.
// These pages are not marketing pages, so they must never carry
// public SEO metadata (marketing descriptions, canonicals, keywords).
const TITLES: Record<string, string> = {
  "/index": "Dashboard",
  "/profile": "Profile",
  "/prospecting": "Prospecting",
  "/weeks": "Weekly Log",
  "/stages": "Pipeline",
  "/trade-shows": "Trade Shows",
  "/contacts": "Contacts",
  "/reports": "Reports",
  "/planning": "Planning",
  "/mapping": "Mapping",
  "/corporation": "Corporation",
  "/communicator": "Communicator",
  "/manage-subscription": "Manage Subscription",
};

const AppPageMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const name = TITLES[pathname];
    document.title = name ? `${name} | Salesby` : "Salesby";

    const existing = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const previous = existing?.getAttribute("content") ?? null;
    const robots = existing ?? document.createElement("meta");
    robots.setAttribute("name", "robots");
    robots.setAttribute("content", "noindex, nofollow");
    if (!existing) document.head.appendChild(robots);

    return () => {
      if (previous !== null) robots.setAttribute("content", previous);
      else robots.remove();
    };
  }, [pathname]);

  return null;
};

export default AppPageMeta;
